import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseButtonIndex {
  doShowOverviewContent: Function
}

//------------------------------------------------
export function useButtonIndex(): UseButtonIndex {
  const samudkoyStore = useSamudkoyStore()

  function doShowOverviewContent() {
    samudkoyStore.showOverviewContent()
  }

  return {
    doShowOverviewContent,
  }
}

//------------------------------------------------
export function useButtonIndexMock(): UseButtonIndex {
  function doShowOverviewContent() {
    console.debug('doShowOverviewContent()')
  }

  return {
    doShowOverviewContent,
  }
}
